module.exports = __webpack_public_path__ + "media/components/maps/incidents/icons/criminality-212d5a4de8a3ca551a9229b9c5daa4ba.png";